import Swiper from "swiper";
import { Mousewheel, Navigation } from "swiper/modules";
import { trackEvent } from "../made-category-print-analytics";

// eslint-disable-next-line import/extensions -- swiper package does not use .scss extension
import "swiper/css";

function $getUseCasesRoot() {
  return document.querySelector(".made-category-print-use-cases");
}

function $getUseCasesContainer($root) {
  return $root?.querySelector(".js-use-cases-swiper");
}

function $getUseCasesPrevBtn($root) {
  return $root?.querySelector(".js-use-cases-prev");
}

function $getUseCasesNextBtn($root) {
  return $root?.querySelector(".js-use-cases-next");
}

function trackCarouselNav(direction) {
  trackEvent("clp_use_cases_carousel_navigated", {
    section_identifier: "use_cases",
    direction,
    eventLabel: direction
  });
}

export default function initUseCases() {
  const $root = $getUseCasesRoot();
  if (!$root) return;

  const $container = $getUseCasesContainer($root);
  const $prevBtn = $getUseCasesPrevBtn($root);
  const $nextBtn = $getUseCasesNextBtn($root);
  if (!$container || !$prevBtn || !$nextBtn) return;

  // Guard: if swiper already exists on this container, just update and bail.
  // This prevents duplicate tracking listeners on repeated init calls.
  if ($container.swiperInstance) {
    $container.swiperInstance.update();
    return;
  }

  const swiper = new Swiper($container, {
    modules: [Mousewheel, Navigation],
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    navigation: {
      prevEl: $prevBtn,
      nextEl: $nextBtn,
      addIcons: false
    },
    breakpoints: {
      768: {
        spaceBetween: 40
      }
    }
  });

  $container.swiperInstance = swiper;
  $prevBtn.addEventListener("click", () => trackCarouselNav("left"));
  $nextBtn.addEventListener("click", () => trackCarouselNav("right"));
}
